import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FlaskConical } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { PageHeader } from "../components/app/PageHeader";
import { Md } from "./Analyst";

export default function PpcSummaries() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/ppc/summaries").then((r) => { setData(r.data); setOpen(r.data.items[0]?.draft_id || null); }).catch((e) => toast.error(errMsg(e)));
  }, []);
  const cur = data?.items.find((x) => x.draft_id === open);
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Gi-aprobahan sa Kura Paroko" title="Mga Summary sa PPC" testId="ppc-summaries-header">
        Binulan nga summary sa Parish Pastoral Council sa Binisaya, para sa mga lider sa GKK. Gi-andam uban sa tabang sa AI ug gisusi sa mga tawo.
      </PageHeader>
      {data?.contains_test_data && <p className="flex items-center gap-2 rounded-lg bg-amber-100 px-3 py-2 text-sm font-semibold text-amber-900" data-testid="ppc-summaries-test-banner"><FlaskConical className="h-4 w-4" />TEST / SAMPLE DATA — dili tinuod nga rekord sa parokya</p>}
      <div className="grid gap-6 lg:grid-cols-[240px_1fr]">
        <aside className="space-y-2" data-testid="ppc-summaries-list">
          {data?.items.map((s) => (
            <button key={s.draft_id} onClick={() => setOpen(s.draft_id)} className={`block w-full rounded-lg px-3 py-2 text-left text-sm ${open === s.draft_id ? "bg-amber-100" : "hover:bg-[#F5F0E6]"}`} data-testid={`ppc-summary-item-${s.draft_id}`}>
              <p className="font-semibold text-stone-800">{s.start} hangtod {s.end}</p>
              <p className="text-xs text-stone-500">Gi-aprobahan ni {s.ceb_approved_by}</p>
            </button>
          ))}
          {data && !data.items.length && <p className="text-sm text-stone-500" data-testid="ppc-summaries-empty">Wala pay gi-aprobahan nga summary.</p>}
        </aside>
        {cur && (
          <article className="min-w-0 rounded-xl border border-amber-700/15 bg-white p-6" data-testid="ppc-summary-content">
            <p className="mb-4 text-xs text-stone-500">Panahon {cur.start} hangtod {cur.end} · Gi-aprobahan ni {cur.ceb_approved_by} niadtong {cur.ceb_approved_at.slice(0, 10)}</p>
            <Md text={cur.ceb_content} />
          </article>
        )}
      </div>
    </div>
  );
}
